import axiosInstance from "../../axios";
import {
  GET_ARRAY_OF_DASHBOARD,
  GET_JSON_OF_DASHBOARD,
} from "../types/dashboardTypes";

import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { claimOrgScopedRequest } from "./orgScopedRequest";

export function getArrayOfDashboard(items) {
  return {
    type: GET_ARRAY_OF_DASHBOARD,
    payload: items,
  };
}

export function getJsonOfDashboard(items) {
  return {
    type: GET_JSON_OF_DASHBOARD,
    payload: items,
  };
}

export function getDashboardData(orgaID, page) {
  return async (dispatch) => {
    const isCurrent = claimOrgScopedRequest("dashboard");
    dispatch(requestStarted("dashboard"));
    // Dropped before the request leaves - see orgScopedRequest.
    dispatch(getJsonOfDashboard({}));
    try {
      const res = await axiosInstance.get(
        `/scoring/view_risk_profile/${orgaID}?page=${page}`
      );
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      dispatch(getJsonOfDashboard(res?.data));
      dispatch(requestSucceeded());
    } catch (error) {
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      dispatch(requestFailed(error?.response?.data));
    }
  };
}

export function getExportAllData(orga_id) {
  return async (dispatch) => {
    dispatch(requestStarted("orga"));

    try {
      const apiEndpoints = [
        `/scoring/final_export_risk_profile/${Number(
          orga_id
        )}?page=orga_description`,
        `/scoring/final_export_risk_profile/${Number(orga_id)}?page=tef_values`,
        `/scoring/final_export_risk_profile/${Number(orga_id)}?page=ale_values`,
        `/scoring/final_export_risk_profile/${Number(orga_id)}?page=tlm_values`,
        `/scoring/final_export_risk_profile/${Number(
          orga_id
        )}?page=discovered_assets`,
        `/scoring/final_export_risk_profile/${Number(
          orga_id
        )}?page=proba_values`,
        `/scoring/final_export_risk_profile/${Number(
          orga_id
        )}?page=cost_categories`,
        `/scoring/final_export_risk_profile/${Number(orga_id)}?page=references`,
      ];

      // Fire all requests in parallel
      const requests = apiEndpoints.map((endpoint) =>
        axiosInstance.get(endpoint).then((res) => res?.data?.risk_profile_data)
      );

      // Wait for all to complete
      const data = await Promise.all(requests);
      dispatch(getArrayOfDashboard(data));
      dispatch(requestSucceeded());
    } catch (error) {
      console.error("Export error:", error);
      dispatch(requestFailed(error.response?.data || error.message));
    }
  };
}
